import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/recipes/$recipeId')({
  component: RecipeIdLayout,
});

function RecipeIdLayout() {
  return <Outlet />;
}
